import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { getProduct, categoryTitle, collectionPath, lineOf, productPath, relatedProducts } from '../utils/products';
import { productJsonLd, productMetaDescription } from '../utils/seo';
import { useSeo } from '../hooks/useSeo';
import { site } from '../data/site';
import { ProductGallery } from '../components/product/ProductGallery';
import { BuyBox } from '../components/product/BuyBox';
import { WhyGood } from '../components/product/WhyGood';
import { ProductDetails } from '../components/product/ProductDetails';
import { ProductSection } from '../components/shop/ProductSection';
import { NotFound } from './NotFound';
import type { Product as ProductType } from '../types/product';
export function Product() {
  const {
    slug = ''
  } = useParams();
  const product = getProduct(slug);
  if (!product) return <NotFound data-id="element-676" data-mp="2uue466gea6ok" />;
  return <ProductView key={product.slug} product={product} data-id="element-677" data-mp="2zvld48u9xbwt" />;
}
function ProductView({
  product
}: {
  product: ProductType;
}) {
  const line = lineOf(product);
  const living = line === 'living';
  useSeo({
    title: `${product.name} – ${product.subtitle} | ${living ? site.livingName : site.name}`,
    description: productMetaDescription(product),
    path: productPath(product),
    image: product.image,
    type: 'product',
    jsonLd: productJsonLd(product)
  });
  return <div className="pb-24 lg:pb-0" data-id="element-678" data-mp="8i0zrwavh9jf">
      <div className="mx-auto max-w-7xl px-5 pt-8 lg:px-8 lg:pt-10" data-id="element-679" data-mp="4gfqsm1glfei">
        <nav aria-label="Kruimelpad" className="text-sm text-muted" data-id="element-680" data-mp="4emg8vnq6b18">
          <Link to={living ? '/living' : '/'} className="hover:text-ink" data-id="element-681" data-mp="3vm794z8zvnqr">{living ? 'AMIRA Living' : 'Home'}</Link>
          <span className="mx-2" data-id="element-682" data-mp="3qo5v4sqfeem5">/</span>
          <Link to={collectionPath(product.category, line)} className="hover:text-ink" data-id="element-683" data-mp="3lp2oj3uss0c2">{categoryTitle(product.category)}</Link>
          <span className="mx-2" data-id="element-684" data-mp="1ovhm22r3owyg">/</span>
          <span className="text-ink" data-id="element-685" data-mp="1oug9ftufs2em">{product.name}</span>
        </nav>
        <div className="mt-6 grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-686" data-mp="1jyr75ir187em">
          <div className="lg:col-span-7" data-id="element-687" data-mp="3ed68aknorc1g">
            <div className="lg:sticky lg:top-44" data-id="element-688" data-mp="3ecd67wzo9apn">
              <ProductGallery product={product} data-id="element-689" data-mp="3j4wlqzhx6fx3" />
            </div>
          </div>
          <div className="lg:col-span-5" data-id="element-690" data-mp="34ficdrecfyhp">
            <BuyBox product={product} data-id="element-691" data-mp="34gtcnh8kyo42" />
          </div>
        </div>
      </div>
      <div className="mt-16 lg:mt-24" data-id="element-692" data-mp="39dtjvvh61wwr">
        <WhyGood product={product} data-id="element-693" data-mp="39euw439x4pg2" />
      </div>
      <ProductDetails product={product} data-id="element-694" data-mp="y9uj7jm8ymz" />
      <div className="border-t border-line" data-id="element-695" data-mp="zb4f8owbf34">
        <ProductSection tone={line} title={living ? 'Past er mooi bij' : 'Maak het ritueel compleet'} products={relatedProducts(product)} data-id="element-696" data-mp="5xmg7oyr3znz" />
      </div>
    </div>;
}